import { render, staticRenderFns } from "./TickedIcon.vue?vue&type=template&id=5fba8c76&scoped=true"
import script from "./TickedIcon.vue?vue&type=script&lang=js"
export * from "./TickedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba8c76",
  null
  
)

export default component.exports